import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const AdminSidebar: React.FC = () => {
  const { darkMode } = useTheme();
  
  const logoPath = darkMode 
    ? '/assets/logos/NU-DATA-5+-+logo+dark.png'
    : '/assets/logos/NU-DATA-4+-+logo+-+light.png';
  
  const navLinkClass = ({ isActive }: { isActive: boolean }) => 
    `flex items-center px-4 py-2 mt-2 text-admin-color-primary-800 dark:text-admin-color-primary-200 ${
      isActive 
        ? 'bg-admin-color-primary-100 dark:bg-admin-color-primary-800 rounded-md' 
        : 'hover:bg-admin-color-primary-100 dark:hover:bg-admin-color-primary-800 rounded-md transition-colors'
    }`;
  
  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-64 bg-admin-color-secondary-50 dark:bg-admin-color-secondary-900 border-r border-gray-200 dark:border-gray-700">
        <div className="flex flex-col h-0 flex-1">
          <div className="flex items-center h-16 flex-shrink-0 px-4 bg-admin-color-secondary-100 dark:bg-admin-color-secondary-800">
            <img
              className="h-8 w-auto"
              src={logoPath}
              alt="NU-DATA Admin"
            />
            <span className="ml-2 text-xl font-semibold text-admin-color-secondary-800 dark:text-admin-color-secondary-200">
              Admin Portal
            </span>
          </div>
          <div className="flex-1 flex flex-col overflow-y-auto">
            <nav className="flex-1 px-2 py-4">
              <NavLink to="/admin/dashboard" className={navLinkClass}>
                Dashboard
              </NavLink>
              <NavLink to="/admin/tenants" className={navLinkClass}>
                Tenant Management
              </NavLink>
              <NavLink to="/admin/users" className={navLinkClass}>
                User Management
              </NavLink>
              <NavLink to="/admin/system" className={navLinkClass}>
                System Settings
              </NavLink>
              <NavLink to="/admin/access-control" className={navLinkClass}>
                Access Control
              </NavLink>
              <NavLink to="/admin/notifications" className={navLinkClass}>
                Notification Settings
              </NavLink>
              <NavLink to="/admin/billing" className={navLinkClass}>
                Billing & Subscriptions
              </NavLink>
              <NavLink to="/admin/audit-logging" className={navLinkClass}>
                Audit Logging
              </NavLink>
              <NavLink to="/admin/tenant-migration" className={navLinkClass}>
                Tenant Migration
              </NavLink>
              <NavLink to="/admin/white-labeling" className={navLinkClass}>
                White-labeling
              </NavLink>
              <NavLink to="/admin/api-monitoring" className={navLinkClass}>
                API Monitoring
              </NavLink>
              
              {/* Advanced Security & Monitoring */}
              <div className="mt-4 mb-2">
                <h3 className="px-4 text-xs font-semibold text-admin-color-primary-600 dark:text-admin-color-primary-400 uppercase tracking-wider">
                  Security & Monitoring
                </h3>
              </div>
              <NavLink to="/admin/threat-detection" className={navLinkClass}>
                Threat Detection
              </NavLink>
              <NavLink to="/admin/enhanced-monitoring" className={navLinkClass}>
                Enhanced Monitoring
              </NavLink>
              <NavLink to="/admin/zero-trust-auth" className={navLinkClass}>
                Zero Trust Auth
              </NavLink>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSidebar;
